import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

// Simple animated counter (integers or 1-decimal floats)
function Counter({ to, decimals = 0, duration = 900 }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (to === null || to === undefined) return;
    let raf, start;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min(1, (ts - start) / duration);
      setN(to * (0.15 + 0.85 * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);
  return (
    <span className="tabular-nums">
      {n.toLocaleString(decimals ? "es-ES" : "es-ES", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
    </span>
  );
}

function Card({ testid, label, value, decimals = 0, unit }) {
  const isEmpty = value === null || value === undefined;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
      className="rounded-2xl border hairline bg-white p-6 lg:p-8 min-h-[160px] flex flex-col justify-between"
      data-testid={testid}
    >
      <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
        {label}
      </div>
      <div className="font-serif text-4xl lg:text-5xl text-salnes-ink mt-6">
        {isEmpty ? "—" : <Counter to={Number(value)} decimals={decimals} />}
        {!isEmpty && unit && (
          <span className="text-base text-salnes-stone ml-2 tracking-normal">
            {unit}
          </span>
        )}
      </div>
    </motion.div>
  );
}

export default function ImpactoKpiGrid({ data }) {
  const { t } = useTranslation();
  const k = data?.kpis || {};
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
      data-testid="impacto-kpi-grid"
    >
      <Card
        testid="impacto-kpi-days"
        label={t("fase7.kpi_days_operational")}
        value={data?.days_operational}
      />
      <Card
        testid="impacto-kpi-detecciones"
        label={t("fase7.kpi_detecciones")}
        value={k.detecciones_procesadas}
      />
      <Card
        testid="impacto-kpi-concellos"
        label={t("fase7.kpi_concellos")}
        value={k.concellos_integrados}
      />
      <Card
        testid="impacto-kpi-habitantes"
        label={t("fase7.kpi_habitantes")}
        value={k.habitantes_beneficiados}
      />
      <Card
        testid="impacto-kpi-api-calls"
        label={t("fase7.kpi_api_calls_30d")}
        value={k.consultas_api_publica_30d}
      />
      <Card
        testid="impacto-kpi-datasets"
        label={t("fase7.kpi_datasets")}
        value={k.datasets_publicos}
      />
    </div>
  );
}
